import React, { useState } from 'react';
import styled from 'styled-components';
import { MapContainer as LeafletMap, TileLayer, GeoJSON, Marker, Tooltip } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

import BolinawanGeoJSON from '../Geojson/Bolinawan.geojson';
import SanFranciscoGeoJSON from '../Geojson/SanFrancisco.geojson';
import CamalianGeoJSON from '../Geojson/Camalian.geojson';
import CagawasanGeoJSON from '../Geojson/Cagawasan.geojson';
import TuboranGeoJSON from '../Geojson/Tuboran.geojson';
import SanJoseGeoJSON from '../Geojson/SanJose.geojson';
import BenliwGeoJSON from '../Geojson/Benliw.geojson';

import LocationMarkerIcon from '../Assets/Icon1.png';

const customMarkerIcon = new L.Icon({
  iconUrl: LocationMarkerIcon,
  iconSize: [32, 32],
  iconAnchor: [16, 32],
  popupAnchor: [0, -32],
});

const Offices = () => {
  const [selectedMap, setSelectedMap] = useState(null);

  const mapData = {
    'Bolinawan, Carcar, Cebu': {
      coords: [10.2833, 123.6333],
      title: 'Cebu Office: Bolinawan, Carcar',
      geojson: BolinawanGeoJSON,
    },
    'San Francisco, Ubay, Bohol': {
      coords: [10.0667, 124.4667],
      title: 'San Francisco, Ubay',
      geojson: SanFranciscoGeoJSON,
    },
    'Camali-an, Ubay, Bohol': {
      coords: [10.0500, 124.4667],
      title: 'Camali-an, Ubay',
      geojson: CamalianGeoJSON,
    },
    'Cagawasan, Pilar, Bohol': {
      coords: [9.8333, 124.3333],
      title: 'Cagawasan, Pilar',
      geojson: CagawasanGeoJSON,
    },
    'Tuboran, Ubay, Bohol': {
      coords: [10.0333, 124.4833],
      title: 'Tuboran, Ubay',
      geojson: TuboranGeoJSON,
    },
    'San Jose, Talibon, Bohol': {
      coords: [10.1167, 124.3167],
      title: 'San Jose, Talibon',
      geojson: SanJoseGeoJSON,
    },
    'Benliw, Ubay, Bohol': {
      coords: [10.0667, 124.4500],
      title: 'Benliw, Ubay',
      geojson: BenliwGeoJSON,
    },
  };

  const handleViewMap = (location) => {
    setSelectedMap(location);
  };

  const handleCloseMap = () => {
    setSelectedMap(null);
  };

  const getCentroid = (geojson) => {
    try {
      if (!geojson?.features?.[0]?.geometry?.coordinates) return null;
      const coords = geojson.features[0].geometry.coordinates;
      const avgLat = coords.reduce((sum, [lon, lat]) => sum + lat, 0) / coords.length;
      const avgLon = coords.reduce((sum, [lon, lat]) => sum + lon, 0) / coords.length;
      return [avgLat, avgLon];
    } catch {
      return null;
    }
  };

  const renderGeoJSON = (geojson) => {
    try {
      if (!geojson?.features?.length) return null;
      return (
        <GeoJSON
          data={geojson}
          style={() => ({
            color: '#00a8b5',
            weight: 2,
            fillColor: '#f0f7fa',
            fillOpacity: 0.7,
          })}
        />
      );
    } catch {
      return null;
    }
  };

  return (
    <Container>
      <OfficeDetails>
        <Title>OFFICE LOCATIONS</Title>

        <OfficeItem>
          <strong>BOHOL - CEBU-SEQUIJOR IMO (CEBU OFFICE)</strong>
          <p>BOLINAWAN, CARCAR, CEBU</p>
          <p>Phone: 09247692281</p>
          <p>Email: Sample1@gmail.com</p>
          <ViewMapButton onClick={() => handleViewMap('Bolinawan, Carcar, Cebu')}>View Map</ViewMapButton>
        </OfficeItem>

        <OfficeItem>
          <strong>BOHOL - CEBU-SEQUIJOR IMO (BOHOL OFFICE)</strong>
          <p>SAN FRANCISCO, UBAY, BOHOL</p>
          <p>Phone: 09458869321</p>
          <p>Email: Sample2@gmail.com</p>
          <ViewMapButton onClick={() => handleViewMap('San Francisco, Ubay, Bohol')}>View Map</ViewMapButton>
        </OfficeItem>

        <OfficeItem>
          <strong>BOHOL INTEGRATED IRRIGATION SYSTEM</strong>
          <p>CAMALI-AN, UBAY, BOHOL</p>
          <ViewMapButton onClick={() => handleViewMap('Camali-an, Ubay, Bohol')}>View Map</ViewMapButton>
          <p>CAGAWASAN, PILAR, BOHOL</p>
          <ViewMapButton onClick={() => handleViewMap('Cagawasan, Pilar, Bohol')}>View Map</ViewMapButton>
          <p>TUBORAN, UBAY, BOHOL</p>
          <ViewMapButton onClick={() => handleViewMap('Tuboran, Ubay, Bohol')}>View Map</ViewMapButton>
          <p>SAN JOSE, TALIBON, BOHOL</p>
          <ViewMapButton onClick={() => handleViewMap('San Jose, Talibon, Bohol')}>View Map</ViewMapButton>
          <p>BENLIW, UBAY, BOHOL</p>
          <ViewMapButton onClick={() => handleViewMap('Benliw, Ubay, Bohol')}>View Map</ViewMapButton>
        </OfficeItem>
      </OfficeDetails>

      {selectedMap && (
        <MapOverlay>
          <MapPopup>
            <LeafletMap
              center={getCentroid(mapData[selectedMap].geojson) || mapData[selectedMap].coords}
              zoom={13}
              style={{ height: '500px', width: '100%', borderRadius: '10px' }}
            >
              <TileLayer
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                attribution='© <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
              />
              <>
                {renderGeoJSON(mapData[selectedMap].geojson)}
                <Marker position={mapData[selectedMap].coords} icon={customMarkerIcon}>
                  <Tooltip direction="top" offset={[0, -10]} opacity={1}>
                    {mapData[selectedMap].title}
                  </Tooltip>
                </Marker>
              </>
            </LeafletMap>
            <CloseButton onClick={handleCloseMap}>Close</CloseButton>
          </MapPopup>
        </MapOverlay>
      )}
    </Container>
  );
};

export default Offices;

const Container = styled.div`
  font-family: 'Arial', sans-serif;
  background: linear-gradient(135deg, #f0f7fa, #d9e9f2);
  padding: 50px;
  max-width: 1300px;
  margin: 0 auto;
  border-radius: 20px;
  display: flex;
  align-items: flex-start;
  gap: 40px;
  justify-content: center;
  box-shadow: 0 15px 40px rgba(0, 0, 0, 0.15);
`;

const OfficeDetails = styled.div`
  flex: 2;
  padding: 30px;
  background: linear-gradient(135deg, #ffffff, #f0f7fa);
  border-radius: 20px;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
  max-height: 500px;
  overflow-y: auto;
  border-left: 5px solid #2a6e4b;
`;

const Title = styled.h2`
  font-size: 32px;
  font-weight: 800;
  color: #2a4e6e;
  margin-bottom: 25px;
  text-align: center;
`;

const OfficeItem = styled.div`
  font-size: 18px;
  line-height: 2;
  color: #333;
  margin-bottom: 25px;
  padding: 20px;
  background: #ffffff;
  border-radius: 10px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
`;

const ViewMapButton = styled.button`
  margin-top: 10px;
  padding: 8px 16px;
  background-color: rgb(10, 65, 3);
  color: rgb(255, 255, 255);
  border: none;
  border-radius: 5px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  &:hover {
    background-color: rgb(50, 110, 42);
  }
`;

const MapOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
`;

const MapPopup = styled.div`
  width: 90%;
  max-width: 800px;
  background: rgb(255, 255, 255);
  border-radius: 10px;
  box-shadow: 0 5px 25px rgba(0, 0, 0, 0.2);
  position: relative;
  padding: 5px 10px;
  animation: fadeIn 0.3s ease-in-out;

  @keyframes fadeIn {
    from { opacity: 0; transform: scale(0.95); }
    to { opacity: 1; transform: scale(1); }
  }
`;

const CloseButton = styled.button`
  position: absolute;
  top: 10px;
  right: 10px;
  background-color: #ff7e79;
  color: #ffffff;
  border: none;
  border-radius: 5px;
  padding: 5px 10px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  z-index: 1000;

  &:hover {
    background-color: #2a4e6e;
  }
`;
